import React from "react";

const SongCommentItem = ({ comment }) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        padding: "12px 0",
        borderBottom: "1px solid #eee",
      }}
    >
      {/* User Image */}
      <img
        src={comment.userImage || "/default-avatar.png"}
        alt={comment.userName}
        style={{
          width: "36px",
          height: "36px",
          borderRadius: "50%",
          objectFit: "cover",
        }}
      />

      <div style={{ flex: 1 }}>
        <strong style={{ fontSize: "14px" }}>
          {comment.userName}
        </strong>

        <p style={{ margin: "4px 0", fontSize: "14px" }}>
          {comment.comment}
        </p>

        <span style={{ fontSize: "12px", color: "#888" }}>
          {new Date(comment.createdAt).toLocaleString()}
        </span>
      </div>
    </div>
  );
};

export default SongCommentItem;